<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "DeleteGlyphModal",
  components: {
    ModalWrapperChoice
  },
  props: {
    idx: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      confirmedDelete: false
    };
  },
  computed: {
    glyph() {
      return Glyphs.findByInventoryIndex(this.idx);
    },
  },
  methods: {
    update() {
      const newGlyph = Glyphs.findByInventoryIndex(this.idx);
      if (this.glyph !== newGlyph && !this.confirmedDelete) {

        // Why is confirmedDelete here: refer to SacrificeGlyphModal.vue

        this.emitClose();
        Modal.message.show("Выбранный Глиф изменил позицию или был как-либо иначе изменён!");
      }
    },
    handleYesClick() {
      this.confirmedDelete = true;
      Glyphs.removeFromInventory(this.glyph);
    },
  },
};
</script>

<template>
  <ModalWrapperChoice @confirm="handleYesClick">
    <template #header>
      Вы собираетесь удалить Глиф
    </template>
    <div class="c-modal-message__text">
      Удаление Глифа уберёт Глиф из вашего инвентаря!
      <div class="c-modal-hard-reset-danger">
        Нет никакой выгоды в удалении Глифа до того как вы открыли Жертвование Глифов!
      </div>
    </div>
  </ModalWrapperChoice>
</template>
